import { Icons } from '@munifocus/ui';
import { useTranslation } from 'react-i18next';
import { useMyCertifications } from '../../lib/certifications-api';
import { CertificationList } from '../certifications/CertificationList';
import { SettingsSection } from './SettingsSection';

/**
 * The signed-in officer's own training certifications. Read-only: certificates
 * are issued by MuniFocus after training, and the empty state says so, rather
 * than inviting the officer to add one here.
 */
export function CertificationsSection() {
  const { t } = useTranslation();
  const mine = useMyCertifications();
  return (
    <SettingsSection
      icon={Icons.Award}
      title={t('gov.certifications.title')}
      description={t('gov.certifications.description')}
    >
      <CertificationList
        summary={mine.data}
        isLoading={mine.isLoading}
        isError={mine.isError}
        emptyLabel={t('gov.certifications.empty')}
      />
    </SettingsSection>
  );
}
